import Event from "./GetEvent.jsx/EventAdmin"
import useFormContext from "./GetEvent.jsx/useFormAdminContext"
import Schedule from "./GetEvent.jsx/ScheduleAdmin"
import Guests from "./GetEvent.jsx/GuestsAdmin"
import Summary from "./GetEvent.jsx/SummaryAdmin"
import History from "./GetEvent.jsx/HistoryAdmin"

const FormInputs = ({ isEditing }) => {

    const { page } = useFormContext()

    const display = {
        0: <Event isEditing={isEditing} />,
        1: <Schedule isEditing={isEditing} />,
        2: <Guests isEditing={isEditing} />,
        3: <History isEditing={isEditing} />,
        4: <Summary isEditing={isEditing} />
    }

    const content = (
        <>
            {display[page]}
        </>
    )


    return content
}
export default FormInputs